import React, { Component } from 'react';
import * as commonActions from '../../../../../../app/common/common.action';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../material.action';
import ChecklistPage from './checklist.page';
import WebapiCommon from '@common/util/webapi.common';

class ChecklistContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalChecklist: false,
      readonly: false,
      historicos: [],
    };
  }

  componentDidMount() {
    WebapiCommon.getHistoricoRespostaQuestionario(
      this.props.detalhes.laudo
    ).then((result) => {
      this.setState({
        historicos: result,
      });
    });
  }

  toggleModalChecklist() {
    if (this.state.modalChecklist) {
      this.atualizarHistorico();
      this.setState({
        respostas: null,
      });
    }

    this.setState((state) => ({
      modalChecklist: !state.modalChecklist,
    }));
  }

  atualizarHistorico() {
    WebapiCommon.getHistoricoRespostaQuestionario(
      this.props.detalhes.laudo
    ).then((result) => {
      this.setState({
        historicos: result,
      });
      this.forceUpdate();
    });
  }

  responderQuestionario() {
    this.setState({
      modalChecklist: true,
      readonly: false,
    });
  }

  formatDate(val) {
    let _val = '';
    if (val) {
      _val = new Date(val).toISOString().slice(0,10);
    }
    return _val;
  }

  visualizarHistorico(historicoId) {
    WebapiCommon.getRespostasQuestionario(historicoId).then((result) => {
      var respostas = result.map((item) => {
        return {
          tipoResposta: item.tipoResposta,
          ordem: item.ordem,
          id: item.idPergunta,
          descricao: item.descricaoPergunta,

          value: item.tipoResposta == 'select' ? {
            label: item.descricaoRespostaEscolhida,
            value: item.idRespostaEscolhida,
          } : item.tipoResposta == 'date' ? this.formatDate(item.descricaoRespostaEscolhida) : item.descricaoRespostaEscolhida,
        };
      });
      this.setState({
        modalChecklist: true,
        readonly: true,
        respostas,
      });
    });
  }

  render() {
    return (
      <ChecklistPage
        readonly={this.state.readonly}
        historicos={this.state.historicos}
        altura={this.props.altura}
        respostas={this.state.respostas}
        modalChecklist={this.state.modalChecklist}
        visualizarHistorico={this.visualizarHistorico.bind(this)}
        responderQuestionario={this.responderQuestionario.bind(this)}
        bloquearRecebimento={this.props.bloquearRecebimento}
        toggleModalChecklist={this.toggleModalChecklist.bind(this)}
        recebimentoFinalizado={this.props.recebimentoFinalizado}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    detalhes: state.commonReducer.detalhes,
    listagem: state.commonReducer.listagem,
    etapa: state.commonReducer.etapa,
    bloquearRecebimento: state.commonReducer.bloquearRecebimento,
    recebimentoFinalizado: state.recebimentoMaterial.recebimentoFinalizado,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(actions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChecklistContainer);



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/material/tabs/checklist/checklist.container.js